const t = {
  name: "AngledRight",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 12V5H6V12C6 12.5523 6.44771 13 7 13H16.5859L13.5859 10L15.0001 8.58582L20.4143 14L15.0001 19.4142L13.5859 18L16.5859 15H7C5.34315 15 4 13.6569 4 12Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as AngledRight
};
